import { PORTAL_FRONTEND_VERSION } from '@repo/constants';
import { isSavedVersionOutdated, useVersionQuery } from '@repo/lib';
import { UpdateDialog } from '@ui/components';
import { FC, memo, ReactNode, useEffect, useState } from 'react';

interface VersionProviderProps {
  children: ReactNode;
}

export const VersionProvider: FC<VersionProviderProps> = memo(
  (props: VersionProviderProps) => {
    const { children } = props;

    const version = useVersionQuery();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
      if (version && isSavedVersionOutdated(PORTAL_FRONTEND_VERSION, version)) {
        setIsOpen(true);
      }
    }, [version]);

    return (
      <>
        <UpdateDialog
          open={isOpen}
          onOpenChange={setIsOpen}
        />
        {children}
      </>
    );
  },
);

VersionProvider.displayName = 'VersionProvider';
